import React, { useContext, useState, useEffect } from "react";
import ContentPage from "components/contentPage/ContentPage";
import { BranchFavouriteContext } from "contexts/BranchFavouriteContext";
import { IBranch } from "types/Branch";
import styles from "./StockStats.module.css";
import { useLocalBranch } from "hooks/LocalStorage";
import { useParams, useHistory, useLocation } from "react-router-dom";
import {
  IMaterialSelectorProps,
  MaterialSelector,
} from "components/materialSelector/MaterialSelector";
import { MaterialContext } from "contexts/MaterialsContext";
import StockStatsGraphs from "components/stockStatsGraphs/StockStatsGraphs";
import { Loading } from "components/loading/Loading";

const StockStats: React.FC = React.memo(() => {
  const { id } = useParams<{ id: string }>();
  const { branches } = useContext(BranchFavouriteContext);
  const [selectedBranch] = useLocalBranch(
    branches.length > 0 ? branches[0] : undefined
  );
  const { rawMaterialsArrForFoodAnalysis, rawMaterialsMapForFoodAnalysis } =
    useContext(MaterialContext).branchWiseMaterialsMap.get(selectedBranch!.id)!;
  const defaultMaterial =
    rawMaterialsMapForFoodAnalysis.size > 0
      ? rawMaterialsMapForFoodAnalysis.get(id)
      : undefined;

  const [selectedMaterial, setSelectedMaterial] = useState(defaultMaterial);
  const history = useHistory();
  const queryStr = useLocation().search;

  useEffect(() => {
    if (
      rawMaterialsMapForFoodAnalysis.size > 0 &&
      rawMaterialsMapForFoodAnalysis.has(id)
    ) {
      setSelectedMaterial(rawMaterialsMapForFoodAnalysis.get(id));
    }
  }, [rawMaterialsMapForFoodAnalysis, id, setSelectedMaterial]);

  useEffect(() => {
    if (
      selectedMaterial &&
      defaultMaterial &&
      selectedMaterial !== defaultMaterial
    ) {
      history.replace({
        pathname: `/stock-stats/${selectedMaterial?.id}`,
        search: queryStr,
      });
    }
  }, [selectedMaterial, defaultMaterial, history, queryStr]);
  // // TODO handle no branches error
  if (!selectedBranch || !selectedMaterial) {
    return <Loading isLoading={true} />;
  }
  return (
    <ContentPage
      header={
        <Header
          materials={rawMaterialsArrForFoodAnalysis!}
          materialsMap={rawMaterialsMapForFoodAnalysis}
          selectedMaterial={selectedMaterial}
          setSelectedMaterial={setSelectedMaterial}
        />
      }
      mainContent={
        <MainSection selectedBranch={selectedBranch} materialId={id} />
      }
      rightSection={<RightSection />}
    />
  );
});

const Header: React.FC<IMaterialSelectorProps> = (props) => (
  <>
    <div className={styles.pageName}>{"Stock Stats"}</div>
    <MaterialSelector {...props} />
  </>
);

const MainSection: React.FC<{ selectedBranch: IBranch; materialId: string }> = (
  props
) => (
  <StockStatsGraphs
    selectedBranch={props.selectedBranch}
    materialId={props.materialId}
  />
);

const RightSection: React.FC = () => <></>;

export default StockStats;
